import ProductCard from "./ProductCard";
import { filterMarketplaceProducts } from "../libs/marketplaceProductVisibility";

const ProductGrid = ({
  pages = [],
  products: productsProp,
  productsKey = "products",
  lastElementRef,
  onAddToCart,
}) => {
  const allProducts = filterMarketplaceProducts(
    productsProp?.length
      ? productsProp
      : pages.flatMap((page) => page[productsKey] || page.products || [])
  );

  if (allProducts.length === 0) {
    return <p className="listing-empty">No products found.</p>;
  }

  return (
    <div className="product-category-wrapper">
      {allProducts.map((product, index) => (
        <ProductCard
          key={product._id}
          product={product}
          cardRef={index === allProducts.length - 1 ? lastElementRef : null}
          onAddToCart={onAddToCart}
        />
      ))}
    </div>
  );
};

export default ProductGrid;
